/* istanbul ignore file */
import styled, { css } from 'styled-components';
import { Flex } from '@rebass/grid';

import { variables, LinkButton } from 'app/shared/ui';

const { media } = variables;

export const InsuranceHubHeaderWrapper = styled(Flex).attrs(() => ({
  flexDirection: 'column',
  mt: ['32px', '64px'],
}))`
  & {
    z-index: 1;
  }
  min-height: 538px;
  background-color: var(--sunbeanLight);
  text-align: center;
`;

export const InsuranceHubHeaderTickWrapperSt = styled.span`
  margin-top: 12px;
`;

export const InsuranceHubHeaderCTAWrapper = styled(Flex).attrs(() => ({
  flexDirection: ['column', 'row'],
  alignItems: 'center',
  justifyContent: 'center',
}))`
  background-color: var(--white);
  min-width: 629px;
  max-width: none;
  width: auto;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
  padding: 16px;
`;

export const AnrufenButton = styled(LinkButton)`
  height: 44px;
  font-size: 14px;
  background-color: var(--sunbeanBlue);
  color: var(--brandSecondaryLight);

  ${media.sm(css`
    width: 319px;
    margin-right: 0;
  `)}

  ${media.md(css`
    width: 281px;
    margin-right: 16px;
  `)}
`;

export const TarifOnlineButton = styled(LinkButton)`
  height: 44px;
  font-size: 14px;

  ${media.sm(css`
    width: 319px;
    margin-left: 0;
  `)}

  ${media.md(css`
    width: 189px;
    margin-left: 16px;
  `)}
`;

export const PartnerShipwrapper = styled(Flex).attrs(() => ({
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'var(--sunbeanSuperLight)',
  mt: ['0px', '31px'],
  flexDirection: ['column', 'row'],
}))`
  min-height: 48px;
`;

export const HeaderText = styled.h2`
  font-size: 32px;
  line-height: 46px;
  font-weight: 700;
  margin-top: 64px;
`;
